"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        flexShrink: 0,
        marginRight: 20,
        '&:last-child': {
            marginRight: 0
        }
    }
});
//# sourceMappingURL=header.section.item.style.js.map